import React from 'react'
import styled from 'styled-components'
import Switch from 'components/_UI/Switch'
import Radio from 'components/_UI/Radio'
import Text from 'components/_UI/Text'
import colors from 'theme/colors'
import fonts from 'theme/fonts'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import Select from 'react-select'
import breakpoints from 'theme/breakpoints'
import { Settings, Info } from 'lucide-react'

function CertificateSettings({
    autoAvailable,
    setAutoAvailable,
    accessType,
    setAccessType,
    selectedTickets,
    setSelectedTickets,
    ticketOptions,
}) {
    return (
        <Container>
            <SectionHeader>
                <SectionIcon><Settings size={18} color={colors.occasionalPurple} /></SectionIcon>
                <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                    Outras configurações
                </Text>
            </SectionHeader>

            <SettingsGrid>
                <SettingsLeft>
                    <SettingCard>
                        <Text name='small' type='bold' color={colors.nightDark} paddingBottom={0}>
                            Disponibilizar o certificado automaticamente?
                        </Text>
                        <Column marginTop='10px'>
                            <Switch
                                label={autoAvailable ? 'Sim' : 'Não'}
                                labelSize={fonts.sizes.small}
                                onChange={setAutoAvailable}
                                checked={autoAvailable}
                            />
                        </Column>
                    </SettingCard>

                    <SettingCard>
                        <Text name='small' type='bold' color={colors.nightDark} paddingBottom={0}>
                            Quem terá acesso aos certificados?
                        </Text>

                        <Column marginTop='10px' gap='8px'>
                            <Radio
                                selected={accessType === 'all_confirmed'}
                                label='Todos os participantes confirmados'
                                textSize={fonts.sizes.small}
                                onSelect={() => setAccessType('all_confirmed')}
                            />
                            <Radio
                                selected={accessType === 'specific_tickets'}
                                label='Apenas os participantes que fizerem check-in'
                                textSize={fonts.sizes.small}
                                onSelect={() => setAccessType('specific_tickets')}
                                style={{ marginTop: 6 }}
                            />
                        </Column>
                    </SettingCard>

                    <SettingCard>
                        <Text name='small' type='bold' color={colors.nightDark} paddingBottom={0}>
                            Definir os tipos de ingressos que geram certificado
                        </Text>
                        <SelectWrapper>
                            <Select
                                isMulti
                                placeholder='Selecione os tipos de ingresso...'
                                value={selectedTickets}
                                options={ticketOptions}
                                onChange={setSelectedTickets}
                                noOptionsMessage={() => 'Nenhum ingresso disponível'}
                            />
                        </SelectWrapper>
                    </SettingCard>
                </SettingsLeft>

                <SettingsRight>
                    <InfoCard>
                        <InfoHeader>
                            <Info size={16} color={colors.primaryLight} />
                            <Text name='small' type='bold' color={colors.nightDark} paddingBottom={0}>
                                Acesso aos certificados
                            </Text>
                        </InfoHeader>

                        <Text name='small' color={colors.night} paddingBottom={0} marginTop='10px'>
                            Os certificados também podem ser enviados manualmente para todos os participantes do evento ou para participantes específicos em caso de necessidade.
                        </Text>
                        <Text name='small' color={colors.night} paddingBottom={0} marginTop='10px'>
                            Os certificados podem ser acessados pelos próprios <strong>participantes</strong> na web e no app. Você pode definir essa configuração logo abaixo.
                        </Text>
                        <Text name='small' color={colors.night} paddingBottom={0} marginTop='10px'>
                            <strong>Um mesmo modelo de certificado</strong> é enviado para todos os tipos de ingresso escolhidos. Os certificados só estarão disponíveis, tanto por e-mail quanto via "Meus ingressos", após o término do evento.
                        </Text>
                    </InfoCard>
                </SettingsRight>
            </SettingsGrid>
        </Container>
    )
}

export default CertificateSettings

const Container = styled(Column)`
    width: 100%;
    margin-top: 28px;
    padding-top: 24px;
    border-top: 1px solid ${colors.neutralDark};
`

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
`

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`

const SettingsGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
    }
`

const SettingsLeft = styled(Column)`
    flex: 1;
    gap: 12px;
`

const SettingsRight = styled(Column)`
    width: 100%;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 340px;
        flex-shrink: 0;
    }
`

const SettingCard = styled.div`
    background: ${colors.neutralBackground};
    border: 1px solid ${colors.neutralDark};
    border-radius: 10px;
    padding: 16px;
`

const InfoCard = styled.div`
    background: ${colors.neutralBackground};
    border: 1px solid ${colors.neutralDark};
    border-radius: 10px;
    padding: 18px;
`

const InfoHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

const SelectWrapper = styled.div`
    width: 100%;
    margin-top: 10px;

    & > div > div {
        text-align: left;
        font-size: ${fonts.sizes.small};
    }
`
